import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";


// Import Authentication pages
import Login from "../Pages/Authentication/Login";

// Import Utility Pages
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

//New
import Add from "../Pages/Add";
import BullcoAdd from "../Pages/Add/BullcoAdd";

import AddVip from "../Pages/Add/ForVip";
import BullcoAddVip from "../Pages/Add/BullcoAddVip";

import Predictions from "../Pages/Predictions/Predictions";
import BullcoPredictions from "../Pages/Predictions/BullcoPredictions";

import Coupons from "../Pages/Predictions/Coupons";
import BullcoCoupons from '../Pages/Predictions/BullcoCoupons'

import Vips from "../Pages/Predictions/Vip";
import BullcoVip from "../Pages/Predictions/BullcoVip";

import SingleCoupon from "../Pages/Predictions/SingleCoupon";
import BullcoSingleCoupons from "../Pages/Predictions/BullcoSingleCoupon";

import Mentor from "../Pages/Users/Mentor";
import Bullco from "../Pages/Users/Bullco";
import Zixo from "../Pages/Users/Zixo";
import Testudo from "../Pages/Users/Testudo";
import Fox from "../Pages/Users/Fox";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // Calender
  { path: "/add", component: <Add /> },
  { path: "/bullcoadd", component: <BullcoAdd /> },


  { path: "/add-vip", component: <AddVip /> },
  { path: "/bullcoadd-vip", component: <BullcoAddVip /> },


  { path: "/predictions", component: <Predictions /> },
  { path: "/bullcopredictions", component: <BullcoPredictions /> },


  { path: "/coupons", component: <Coupons /> },
  { path: "/bullcocoupons", component: <BullcoCoupons /> },


  { path: "/vip-matches", component: <Vips /> },
  { path: "/vip-matches-bullco", component: <BullcoVip /> },


  { path: "/edit-coupon/:id", component: <SingleCoupon /> },
  { path: "/bullcoedit-coupon/:id", component: <BullcoSingleCoupons /> },

  
  {path:"/users/mentor" , component:<Mentor />},
  {path:"/users/bullco" , component:<Bullco />},
  {path:"/users/zixo" , component:<Zixo />},
  {path:"/users/testudo" , component:<Testudo />},
  {path:"/users/fox" , component:<Fox />},
{
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [

  { path: "/login", component: <Login /> },

  // Utility Pages
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
